import React from "react";

export default function SQL_ORDER_BY() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_ORDER_BY</h1>
      <p>This is the SQL_ORDER_BY component generated from the SQL JSON.</p>
    </div>
  );
}
